import licenseModule from '../../license.module';
import $ from 'jquery';

export default licenseModule.component('licenseManageReallocation', {
    template: require('./licenseManageReallocation.component.html'),
    controller: [
        'LicenseManagementService',
        licenseManageReallocationComponent
    ],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseManageReallocationComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        vm.data = vm.resolve.data;
        vm.appspaceIdSummary = vm.resolve.appspaceIdSummary;
        vm.payload = '';

        vm.license = {
            subscription: {
                maxDevices: vm.data.allocated.subscription.deviceId,
                maxUsers: vm.data.allocated.subscription.premiumUserId,
                symmetric: true,
                reallocated: 0
            },
            perpetual: {
                maxDevices: vm.data.allocated.perpetual.deviceId,
                maxUsers: vm.data.allocated.perpetual.premiumUserId,
                symmetric: true,
                reallocated: 0
            },
            payload: '',
            hideButton: false
        };
        vm.navs = getNavigation();
        vm.currentWorkflow = vm.navs[0];
        vm.valid = false;
    };

    function getNavigation() {
        var nav,
            navs = [];
        if (vm.appspaceIdSummary.subscription.premiumUserId.total > 0) {
            nav = {
                label: 'Subscription',
                value: 'subscription',
                component: 'licenseManageSubscriptionId',
                resolve: {
                    instance: {
                        maxDevices: vm.data.allocated.subscription.deviceId,
                        maxUsers: vm.data.allocated.subscription.premiumUserId
                    },
                    summary: vm.appspaceIdSummary.subscription,
                    license: vm.license.subscription,
                    instanceName: vm.data.name
                },
                callback: function(data) {
                    vm.valid = true;
                    if (
                        !data.eula ||
                        data.license.maxUsers < 1 ||
                        // Disable button if exceeds max users for subscription
                        data.license.maxUsers >
                            vm.appspaceIdSummary.subscription.premiumUserId
                                .total -
                                vm.appspaceIdSummary.subscription.premiumUserId
                                    .usage +
                                vm.data.allocated.subscription.premiumUserId ||
                        // Disable button if exceeds max devices for subscription
                        data.license.maxDevices >
                            vm.appspaceIdSummary.subscription.deviceId.total -
                                vm.appspaceIdSummary.subscription.deviceId
                                    .usage +
                                vm.data.allocated.subscription.deviceId
                    ) {
                        vm.valid = false;
                    }

                    if (
                        ((vm.appspaceIdSummary.type != 'legacy' ||
                            vm.appspaceIdSummary.subscription.premiumUserId
                                .total > 0) &&
                            data.license.maxUsers < 1) ||
                        data.license.maxUsers == undefined
                    ) {
                        vm.valid = false;
                    }

                    var deviceDiff =
                        data.license.maxDevices -
                        vm.data.allocated.subscription.deviceId;
                    var userDiff =
                        data.license.maxUsers -
                        vm.data.allocated.subscription.premiumUserId;
                    var status = symmetricAllocation(deviceDiff, userDiff);
                    vm.license.subscription.symmetric = status.symmetric;
                    vm.license.subscription.reallocated = status.reallocated;
                    if (status.symmetric == false) {
                        vm.valid = false;
                    }
                    if (vm.valid) {
                        vm.license.subscription.maxUsers =
                            data.license.maxUsers;
                        vm.license.subscription.maxDevices =
                            data.license.maxDevices;
                    }
                }
            };
            navs.push(nav);
        }
        if (vm.appspaceIdSummary.perpetual.premiumUserId.total > 0) {
            nav = {
                label: 'Perpetual',
                value: 'perpetual',
                component: 'licenseManagePerpetualId',
                resolve: {
                    instance: {
                        maxDevices: vm.data.allocated.perpetual.deviceId,
                        maxUsers: vm.data.allocated.perpetual.premiumUserId
                    },
                    summary: vm.appspaceIdSummary.perpetual,
                    license: vm.license.perpetual,
                    instanceName: vm.data.name,
                    onlyPerpetual:
                        vm.appspaceIdSummary.type == 'legacy' ||
                        vm.appspaceIdSummary.subscription.premiumUserId.total ==
                            0
                },
                callback: function(data) {
                    vm.valid = true;
                    var deviceDiff =
                        data.license.maxDevices -
                        vm.data.allocated.perpetual.deviceId;
                    var userDiff =
                        data.license.maxUsers -
                        vm.data.allocated.perpetual.premiumUserId;
                    var status = symmetricAllocation(deviceDiff, userDiff);
                    vm.license.perpetual.symmetric = status.symmetric;
                    vm.license.perpetual.reallocated = status.reallocated;
                    if (
                        // Disable button if exceeds max users for perpetual
                        data.license.maxUsers >
                            vm.appspaceIdSummary.perpetual.premiumUserId.total -
                                vm.appspaceIdSummary.perpetual.premiumUserId
                                    .usage +
                                vm.data.allocated.perpetual.premiumUserId ||
                        // Disable button if exceeds max devices for perpetual
                        data.license.maxDevices >
                            vm.appspaceIdSummary.perpetual.deviceId.total -
                                vm.appspaceIdSummary.perpetual.deviceId.usage +
                                vm.data.allocated.perpetual.deviceId
                    ) {
                        vm.valid = false;
                    }

                    if (
                        ((vm.appspaceIdSummary.type == 'legacy' ||
                            vm.appspaceIdSummary.subscription.premiumUserId
                                .total == 0) &&
                            data.license.maxUsers < 1) ||
                        data.license.maxUsers == undefined
                    ) {
                        vm.valid = false;
                    }
                    if (status.symmetric == false) {
                        vm.valid = false;
                    } else {
                        if (
                            vm.license.perpetual.reallocated != 0 &&
                            vm.license.subscription.reallocated != 0 &&
                            vm.license.perpetual.reallocated !=
                                vm.license.subscription.reallocated
                        ) {
                            vm.valid = false;
                            vm.license.perpetual.symmetric = false;
                        }
                    }

                    if (vm.valid) {
                        vm.license.perpetual.maxUsers = data.license.maxUsers;
                        vm.license.perpetual.maxDevices =
                            data.license.maxDevices;
                    }
                },
                disabled: true
            };
            navs.push(nav);
        }

        nav = {
            label: 'Confirmation',
            value: 'confirmation',
            component: 'licenseManageConfirmation',
            resolve: {
                instanceName: vm.data.name,
                license: vm.license,
                onlyPerpetual:
                    vm.appspaceIdSummary.type == 'legacy' ||
                    vm.appspaceIdSummary.subscription.premiumUserId.total == 0
            },
            disabled: true
        };
        navs.push(nav);

        nav = {
            label: 'License',
            value: 'license',
            component: 'licenseManageLicense',
            resolve: {
                license: vm.license
            },
            disabled: true
        };
        navs.push(nav);
        return navs;
    }

    vm.cancel = function() {
        vm.dismiss({ $value: 'cancel' });
    };

    vm.back = function() {
        if (!vm.processing) {
            vm.currentWorkflow.disabled = false;
            vm.currentWorkflow =
                vm.navs[vm.navs.indexOf(vm.currentWorkflow) - 1];
        }
    };
    vm.next = function() {
        vm.currentWorkflow.disabled = false;
        var nextWorkflow = vm.navs[vm.navs.indexOf(vm.currentWorkflow) + 1];
        if (nextWorkflow.value != 'license') {
            vm.currentWorkflow = nextWorkflow;
        }
        if (nextWorkflow.value == 'license') {
            if (!vm.processing) {
                vm.processing = true;
                LicenseManagementService.manageInstanceAllocation(
                    vm.data.id,
                    vm.license
                ).then(
                    function(data) {
                        vm.license.payload = data;
                        vm.currentWorkflow = nextWorkflow;
                        $.each(vm.navs, function(index, value) {
                            if (value.value != 'license') {
                                value.disabled = true;
                                vm.processing = false;
                            }
                        });
                    },
                    function() {
                        vm.license.payload =
                            'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                        vm.license.hideButton = true;
                        vm.currentWorkflow = nextWorkflow;
                        $.each(vm.navs, function(index, value) {
                            if (value.value != 'license') {
                                value.disabled = true;
                                vm.processing = false;
                            }
                        });
                    }
                );
            }
        }
    };

    vm.ok = function() {
        vm.close({ $value: 'ok' });
    };

    function sign(x) {
        return typeof x === 'number'
            ? x
                ? x < 0
                    ? -1
                    : 1
                : x === x
                    ? x
                    : NaN
            : NaN;
    }

    function symmetricAllocation(dataA, dataB) {
        var status = {
            symmetric: false,
            reallocated: 0
        };
        if (dataA == 0) {
            status.reallocated = sign(dataB);
            status.symmetric = true;
        }
        if (dataB == 0) {
            status.reallocated = sign(dataA);
            status.symmetric = true;
        }
        if (status.symmetric == false) {
            status.symmetric = dataA > 0 == dataB > 0;
            if (status.symmetric == true) {
                status.reallocated = sign(dataA);
            }
        }
        return status;
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-manage-reallocation/licenseManageReallocation.component.js